var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WujieVue',{attrs:{"id":"child-app-iframe","width":"100%","alive":true,"height":"100%","name":"eav3","url":_vm.url,"props":{
    parentStore: _vm.$store,
    parentMaxRouter: _vm.$router,
    request: _vm.request,
  },"plugins":_vm.plugins,"activated":_vm.onChildMounted}})
}
var staticRenderFns = []

export { render, staticRenderFns }